module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyv"
  }, [_c('a', {
    attrs: {
      "id": "pl-2"
    }
  }), _vm._v("Publisher: Amy Barrett-Daffin")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Creative Director: Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Acquisitions Editor: Roxane Cerda")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Managing Editor: Liz Aneloski")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Editor: Katie Van Amburg")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Technical Editor: Debbie Rodgers")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover/Book Designer: April Mostek")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Production Coordinator: Tim Manibusan")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Production Editor: Jennifer Warren")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Illustrator: Kirstie L. Pettersen")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Photo Assistant: Lauren Herberg")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Instructional photography by Carrie J. Buck; subjects photography by Estefany Gonzalez of C&T Publishing, Inc., unless otherwise noted")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Published by C&T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c819217","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0003_copyright-title.vue
// module id = 60
// module chunks = 0